import React from 'react';

import cn from 'classnames';

import bem from 'client/services/bem';

import {Translation} from 'client/models/language/types';

import cssModule from './radio-button-group.module.scss';

const b = bem('radio-button-group', {cssModule});

type RadioButton = {
  value: string | number;
  label: React.ReactNode | Translation;
  hidden?: boolean;
};

type RadioButtonGroupProps = {
  name: string;
  radioButtons: RadioButton[];
  legend?: Translation | null;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string | number;
  className?: string;
  controlClassName?: string;
  labelClassName?: string;
  disabled?: boolean;
  direction?: 'horizontal' | 'vertical';
};

const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  legend,
  name,
  radioButtons,
  onChange,
  className = '',
  controlClassName = '',
  labelClassName = '',
  disabled,
  value: fieldsetValue,
  direction = 'horizontal',
}) => {
  return (
    <fieldset className={cn(b([direction]), className)}>
      {legend && <legend className={b('legend')}>{legend}</legend>}

      <div className={cn(b('control', [direction]), controlClassName)}>
        {radioButtons.map(
          ({value, label, hidden}) =>
            !hidden && (
              <div className={b('radio-button', [direction])} key={value}>
                <input
                  type="radio"
                  id={`${name}-${value}`}
                  value={value}
                  name={name}
                  onChange={onChange}
                  className={b('radio-input')}
                  disabled={disabled}
                  checked={value === fieldsetValue}
                  readOnly
                />
                <label htmlFor={`${name}-${value}`} className={cn(b('radio-label', {disabled}), labelClassName)}>
                  <span className={b('radio-value')}>{label}</span>
                </label>
              </div>
            ),
        )}
      </div>
    </fieldset>
  );
};

export default RadioButtonGroup;
